import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';

const Loading = () => (
  <Backdrop open={true} style={{ zIndex: 9000 }}>
    <CircularProgress color="inherit" style={{ color: 'darkgray' }} />
  </Backdrop>
)

export default Loading;